import { Box, IconButton, Toolbar } from '@mui/material';
import { useEffect } from 'react';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon } from '../../../assets/icons';
import { APP_URLS } from '../../../routes/urls';
import { AppIcon } from '../../app-icon/AppIcon';
import { AccountMenu } from '../account-menu/AccountMenu';
import { desktopHeaderStyles } from '../desktop-header/styles';
import { TransformedHeaderProps } from '../types';
import { MobileHeaderDrawer } from './MobileHeaderDrawer';
import { MobileHeaderSkeleton } from './MobileHeaderSkeleton';
import { mobileHeaderStyles } from './styles';
import Logo from '../../../assets/images/logo/nep.png';

export const MobileHeader: React.FC<TransformedHeaderProps> = ({ menus, isLoading }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setIsDrawerOpen(false);
  }, [location]);

  return isLoading ? (
    <MobileHeaderSkeleton />
  ) : (
    <Toolbar sx={desktopHeaderStyles.toolbar} disableGutters className="container-fluid">
      <IconButton color="secondary" aria-label="Open Menu" onClick={() => setIsDrawerOpen(true)}>
        <AppIcon fontSize="medium" Icon={MenuIcon} titleAccess="Open Menu" />
      </IconButton>
      <Box component={Link} to={APP_URLS.home} sx={mobileHeaderStyles.logo}>
        <Box component="img" src={Logo} alt="Nepal Education Portal" />
      </Box>
      <MobileHeaderDrawer isDrawerOpen={isDrawerOpen} onDrawerClose={() => setIsDrawerOpen(false)} menus={menus} />
      <AccountMenu />
    </Toolbar>
  );
};
